/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_StrengthInputs */

const en_portal_goal_strength = /** @type {(inputs: Portal_Goal_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strength`)
};

const pl_portal_goal_strength = /** @type {(inputs: Portal_Goal_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siła`)
};

/**
* | output |
* | --- |
* | "Strength" |
*
* @param {Portal_Goal_StrengthInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_strength = /** @type {((inputs?: Portal_Goal_StrengthInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_StrengthInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_strength(inputs)
	return en_portal_goal_strength(inputs)
});